import { setInputToLocalStorage } from "../search/criteria/utils";

export const useClientState = (criterionKey, saveToClientState) => {
	const onChangeClientState = (input) => {
		return saveToClientState && setInputToLocalStorage(criterionKey, input);
	};

	return { onChangeClientState };
};
